import { useCallback, useEffect, useState } from "react";
import { apiGet } from "./api";

const YMD = /^\d{4}-\d{2}-\d{2}$/;
export const localDay = (d = new Date()) => new Date(d).toLocaleDateString("en-CA");
export const fmtCheckTime = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
};

// Account-wide daily-check completion for a day (default today), kept fresh with
// light polling + a refetch whenever the app returns to the foreground. Every
// staff member on the account therefore sees the SAME status in near-real-time.
export default function useTodayChecks(dateArg, pollMs = 20000) {
  const day = dateArg && YMD.test(dateArg) ? dateArg : localDay();
  const [checks, setChecks] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await apiGet(`/checks/today?date=${day}`);
      setChecks(r.checks || {});
    } catch (e) { /* keep last known status (e.g. offline) */ }
    finally { setLoading(false); }
  }, [day]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, pollMs);
    const onVis = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", refresh);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", refresh);
    };
  }, [refresh, pollMs]);

  return { checks, refresh, loading, day };
}
